export default {
  'NotLogin': 100000
}
